import { Injectable } from '@angular/core';
import { AbstractControlOptions, FormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';

import { MissionLegalEntity } from '@app/forms/subscription/definition/interface/enum';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};
    const missionLegalEntity: any[] =
      entity?.parameters?.missionLegalEntity || [];

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        missionLegalEntity: [entity?.parameters?.missionLegalEntity || []],
        provisionalBudgetOption: [
          missionLegalEntity.includes(MissionLegalEntity.PROVISIONAL_BUDGET) ||
            null,
        ],
        socialMissionOption: [
          missionLegalEntity.includes(MissionLegalEntity.SOCIAL_MISSION) ||
            null,
        ],
        packEssentielOption: [
          missionLegalEntity.includes(MissionLegalEntity.PACK_ESSENTIEL_SCI),
        ],
        packEssentielSciIROption: [
          missionLegalEntity.includes(MissionLegalEntity.PACK_ESSENTIEL_SCI_IR),
        ],
        packSarlOption: [
          missionLegalEntity.includes(MissionLegalEntity.PACK_SARL),
        ],
        packEssentielSci: [entity?.parameters?.packEssentielSci || null],
        packEssentielSciIr: [entity?.parameters?.packEssentielSciIr || null],
        packSarl: [entity?.parameters?.packSarl || null],
        socialMission: [entity?.parameters?.socialMission || null],
        provisionalBudget: [entity?.parameters?.provisionalBudget || 300],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as FormArray;
  }

  extract(): any[] {
    const formValue = _.cloneDeep(this.form?.value?.products);

    const extractedValues = formValue?.map(item => {
      const missionLegalEntity = this.extractMissionLegalEntity(
        item?.parameters,
      );
      const updatedItem = this.removeUnusedFields(item?.parameters);

      return {
        ...item,
        parameters: {
          ...item.parameters,
          ...updatedItem,
          missionLegalEntity,
        },
      };
    });

    return extractedValues;
  }

  private extractMissionLegalEntity(item: any): string[] {
    const missionLegalEntity = [];

    if (
      item.provisionalBudgetOption &&
      !missionLegalEntity.includes(MissionLegalEntity.PROVISIONAL_BUDGET)
    ) {
      missionLegalEntity.push(MissionLegalEntity.PROVISIONAL_BUDGET);
    }
    if (
      item.socialMissionOption &&
      !missionLegalEntity.includes(MissionLegalEntity.SOCIAL_MISSION) &&
      item.socialMission
    ) {
      missionLegalEntity.push(MissionLegalEntity.SOCIAL_MISSION);
    }
    if (
      item.packEssentielOption &&
      !missionLegalEntity.includes(MissionLegalEntity.PACK_ESSENTIEL_SCI)
    ) {
      missionLegalEntity.push(MissionLegalEntity.PACK_ESSENTIEL_SCI);
    }
    if (
      item.packEssentielSciIROption &&
      !missionLegalEntity.includes(MissionLegalEntity.PACK_ESSENTIEL_SCI_IR)
    ) {
      missionLegalEntity.push(MissionLegalEntity.PACK_ESSENTIEL_SCI_IR);
    }
    if (
      item.packSarlOption &&
      !missionLegalEntity.includes(MissionLegalEntity.PACK_SARL)
    ) {
      missionLegalEntity.push(MissionLegalEntity.PACK_SARL);
    }

    return Array.from(new Set(missionLegalEntity));
  }

  private removeUnusedFields(item: any): any {
    const fieldsToRemove = [
      'provisionalBudgetOption',
      'socialMissionOption',
      'packEssentielOption',
      'packEssentielSciIROption',
      'packSarlOption',
    ];

    return _.omit(item, fieldsToRemove);
  }
}
